import { create } from 'zustand';

type DataTableState = {
  currentPageValue: number;
  setCurrentPageValue: (currentPageBtnState: number) => void;
};

export const useDataTableStore = create<DataTableState>((set) => ({
  currentPageValue: 1,
  setCurrentPageValue: (currentPageValue) => set({ currentPageValue }),
}));
